// =============================================================================
// Admin Dashboard Constants
//
// All copy, labels, and confirmation messages for the admin dashboard.
// Zero hardcoded strings in components.
// =============================================================================

export const ADMIN_DASHBOARD = {
  title: "Admin Dashboard",
  subtitle: "Internal tools for managing ClientVitals operations.",
} as const;

export const SYSTEM_CREDENTIALS = {
  title: "System Credentials",
  subtitle: "Rotate the Informativ master password. Do this before the 90 day CBC expiry.",
  form: {
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    submit: "Rotate Password",
  },
  validation: {
    currentPasswordRequired: "Current password is required.",
    newPasswordRequired: "New password is required.",
    confirmPasswordRequired: "Please confirm your new password.",
    passwordsDoNotMatch: "New passwords do not match.",
    passwordTooShort: "Password must be at least 8 characters.",
  },
  success: "Password rotated successfully.",
  error: "Password rotation failed. Check your current password and try again.",
} as const;

export const CLIENT_MANAGEMENT = {
  title: "Client Management",
  subtitle: "Manage client accounts, trigger MAP pulls, and re-onboard clients.",
  search: {
    placeholder: "Search by name or email...",
  },
  empty: "No clients found.",
  error: "Failed to load clients. Please try again.",
  actions: {
    triggerMap: "Trigger MAP",
    reOnboard: "Re-onboard",
    repair: "Repair MAP",
  },
} as const;

export const TRIGGER_MAP_MODAL = {
  title: "Trigger MAP Pull",
  body: (name: string) =>
    `This will manually trigger a credit pull and MAP generation for ${name}. Are you sure?`,
  confirm: "Yes, Trigger MAP",
  cancel: "Cancel",
  success: "MAP pull triggered successfully.",
  error: "MAP pull failed. Please check the client record and try again.",
} as const;

export const RE_ONBOARD_MODAL = {
  title: "Re-onboard Client",
  body: (name: string) =>
    `This will wipe ${name}'s existing account and run a full re-onboard. This action cannot be undone. Are you sure?`,
  confirm: "Yes, Re-onboard",
  cancel: "Cancel",
  success: "Client re-onboarded successfully.",
  error: "Re-onboard failed. Please try again or contact Bernard.",
} as const;

export const REPAIR_MODAL = {
  title: "Repair Client MAP",
  body: (name: string) =>
    `${name}'s CBC user was never created, so no MAP could be generated. Enter their SSN to create the CBC user and pull their credit. The SSN is sent securely and never stored.`,
  ssnPlaceholder: "Enter SSN (9 digits)",
  confirm: "Repair and Pull",
  cancel: "Cancel",
  success: "Client repaired successfully. MAP generated.",
  error: "Repair failed. Please check the client record and try again.",
} as const;


